export const TABLEAU_FILTERS: Record<
  string,
  Record<string, { title: string; category: string }>
> = {
  mobile: {
    master_channel: {
      title: "Channel",
      category: "hierarchy",
    },
    "sr._division": {
      title: "Sr. Division",
      category: "hierarchy",
    },
    master_division: {
      title: "Division",
      category: "hierarchy",
    },
    master_region: {
      title: "Region",
      category: "hierarchy",
    },
    master_rep_name: {
      title: "Rep",
      category: "hierarchy",
    },
    "cancelled?": {
      title: "Cancelled",
      category: "additional",
    },
    master_clean_deal: {
      title: "Clean Deal",
      category: "additional",
    },
    master_lead_source: {
      title: "Lead Source",
      category: "additional",
    },
    master_recruit_source: {
      title: "Recruit Source",
      category: "additional",
    },
    has_adt: {
      title: "Has ADT",
      category: "additional",
    },
    master_block_set: {
      title: "Block Set",
      category: "additional",
    },
  },
};

export const TABLEAU_FILTERS_ORDER: Record<string, string[]> = {
  mobile: [
    "master_channel",
    "sr._division",
    "master_division",
    "master_region",
    "master_rep_name",
    "cancelled?",
    "master_clean_deal",
    "master_lead_source",
    "master_recruit_source",
    "has_adt",
  ],
};

export const TABLEAU_DATE_FILTER: Record<string, string> = {
  mobile: "Date",
};

export const TABLEAU_PARAMETERS: Record<
  string,
  Record<string, { title: string; category?: string; section?: string }>
> = {
  mobile: {
    sort_by: {
      title: "Sort By",
      category: "Additional",
      section: "Additional",
    },
    grouping_level: {
      title: "Grouping Level",
      category: "hierarchy",
      section: "graph_by",
    },
  },
};

export const TABLEAU_PARAMS_ORDER: Record<string, string[]> = {
  mobile: ["grouping_level", "sort_by"],
};

export interface DateRange {
  startDate: Date;
  endDate: Date;
}

export const DATE_RANGE_MAPPINGS: Record<string, (today: Date) => DateRange> = {
  "Last Week": (today) => ({
    startDate: new Date(today.setDate(today.getDate() - 7)),
    endDate: new Date(),
  }),
  "Last Month": (today) => ({
    startDate: new Date(today.setMonth(today.getMonth() - 1)),
    endDate: new Date(),
  }),
  Today: (today) => ({
    startDate: new Date(today),
    endDate: new Date(today),
  }),
  YTD: (today) => ({
    startDate: new Date(today.getFullYear(), 0, 2),
    endDate: new Date(today),
  }),
  Yesterday: (today) => ({
    startDate: new Date(today.setDate(today.getDate() - 1)),
    endDate: new Date(),
  }),
  MTD: (today) => ({
    startDate: new Date(today.getFullYear(), today.getMonth(), 1),
    endDate: new Date(today),
  }),
  "Last Quarter": (today) => ({
    startDate: new Date(today.setMonth(today.getMonth() - 3)),
    endDate: new Date(),
  }),
  "Last Year": (today) => ({
    startDate: new Date(today.setFullYear(today.getFullYear() - 1)),
    endDate: new Date(),
  }),
};
